module.exports = __webpack_public_path__ + "static/media/DOT-BNB.87f731c5.svg";